import React, { useState, useEffect, useMemo } from 'react'
import { Modal, Button, Select, Row, Col, Checkbox, Tooltip } from 'antd'
import { connect } from 'react-redux'
import './LinkModal.css'
import * as com from '../Common'
import * as act from '../Store/actions'
const mapStateToProps = (state) => {
    return {
        application: state.application,
    }
}
const mapDispatchToProps = (dispatch) => ({
    changeBorrowerOwnedProperty: (t, i, v) => {
        dispatch(act.ChangeBorrowerOwnedProperty(t, i, v))
    },
    changeCoborrowerOwnedProperty: (t, i, v) => {
        dispatch(act.ChangeCoborrowerOwnedProperty(t, i, v))
    },
    changeMainProperty: (t, v) => {
        dispatch(act.ChangeMainProperty(t, v))
    },
})
const LinkModal = ({
    application,
    open,
    currentView,
    linkType = 'property',
    onCancel,
    onConfirm,
    changeBorrowerOwnedProperty,
    changeCoborrowerOwnedProperty,
    changeMainProperty,
}) => {
    const [selectedValues, setSelectedValues] = useState({})
    const [propertyMortgages, setPropertyMortgages] = useState({})
    const [unlinkOpen, setUnlinkOpen] = useState(false)
    const [unlinkType, setUnlinkType] = useState('')
    const [unlinkItem, setUnlinkItem] = useState(null)
    useEffect(() => {
        if (open && linkType === 'property') {
            // 重置为当前实际链接状态
            const initialSelectedValues = {};
            LiabilitiesList.forEach((liability, index) => {
                const selectedProperty = getSelectedProperty(liability, properties);
                if (selectedProperty) {
                    initialSelectedValues[index] = selectedProperty;
                }
            });
            setSelectedValues(initialSelectedValues);
        }
        if (open && linkType === 'mortgage') {
            // 初始化每个 property 的已链接 mortgages
            const initialState = {};
            properties.forEach(property => {
                initialState[property.section] = property.loans?.map(loan => loan.key) || [];
            });
            setPropertyMortgages(initialState);
        }
    }, [open, linkType]);

    const getSelectedProperty = (liability, properties) => {
        const matchedProperty = properties.find(property => 
            property.loans?.some(loan => loan.key === liability.key)
        )
    
        if (matchedProperty) {
            return {
                value: matchedProperty.address,
                label: matchedProperty.address,
                data: matchedProperty
            }
        }
    
        return undefined
    }

    const handleLinkChange = (liabilityIndex, option) => {
        const updatedLiability = {
            ...LiabilitiesList[liabilityIndex],
            linkedProperty: option ? option.data.section : ''
        };
        
        const updatedList = [...LiabilitiesList];
        updatedList[liabilityIndex] = updatedLiability;
        setLiabilitiesList(updatedList);

        setSelectedValues(prev => ({
            ...prev,
            [liabilityIndex]: option ? {
                value: option.data.address,
                label: option.label,
                data: option.data,
                displayLabel: option.data.address
            } : undefined
        }))
    }
    const getLiabilities = (application) => {
        const loans = application?.assetsandliabilities?.loans || []
        
        return loans
        .map((loan) => ({
            ...loan,
            ownership: loan.ownership || 'Borrower',
            linkedProperty: loan.linkedProperty || '',
        }))
        .filter(loan => loan.creditliabilityaccounttype === "Mortgage" && loan.name !== '' && loan.accountnumber !== '')
    }
    const getPropertyIndex = (section, isPurchase) => {
        if (section === '3a') return 0;
        if (section === '3b') return isPurchase ? 1 : 0;
        if (section === '3c') return isPurchase ? 2 : 1;
        if (section.startsWith('Extra ')) {
            const extraNum = parseInt(section.split(' ')[1]);
            return isPurchase ? (2 + extraNum) : (1 + extraNum);
        }
        return 0;
    };
    const [LiabilitiesList, setLiabilitiesList] = useState(getLiabilities(application))
    useEffect(() => {
        const updatedLiabilities = getLiabilities(application)
        setLiabilitiesList(updatedLiabilities)
    }, [application?.assetsandliabilities?.loans])
    const handleConfirm = () => {
        onConfirm()
        if (linkType === 'property') {
            const selectedKeys = LiabilitiesList.filter(l => l.linkedProperty).map(l => l.key);
            const isPurchase = application.property.purpose === "purchase";

            // 先清理所有 properties 中的选中项
            if (!isPurchase) {
                // 清理主要房产的 loans
                const mainPropertyLoans = application.property.loans || [];
                const filteredMainLoans = mainPropertyLoans.filter(loan => !selectedKeys.includes(loan.key));
                changeMainProperty(filteredMainLoans, "loans");
            }

            // 清理其他房产的 loans
            const ownedProperties = application[currentView].ownedproperties;
            ownedProperties.forEach((property, index) => {
                const currentLoans = property.loans || [];
                const filteredLoans = currentLoans.filter(loan => !selectedKeys.includes(loan.key));
                if (currentView === "borrower") {
                    changeBorrowerOwnedProperty(filteredLoans, index, "loans");
                } else if (currentView === "coborrower") {
                    changeCoborrowerOwnedProperty(filteredLoans, index, "loans");
                }
            });

            // 按照 linkedProperty 对 liabilities 进行分组
            const liabilitiesByProperty = LiabilitiesList.reduce((acc, liability) => {
                if (liability.linkedProperty) {
                    if (!acc[liability.linkedProperty]) {
                        acc[liability.linkedProperty] = [];
                    }
                    // 创建新的 liability 对象，去掉 linkedProperty
                    const { linkedProperty, ...liabilityWithoutLinked } = liability;
                    acc[liability.linkedProperty].push({
                        ...liabilityWithoutLinked,
                        creditloantype: "ConventionalRealEstateMortgage"
                    });
                }
                return acc;
            }, {});

            // 遍历每个 property section 添加新的 liabilities
            Object.entries(liabilitiesByProperty).forEach(([section, liabilities]) => {
                let propertyIndex;

                // 根据 section 确定 propertyIndex
                switch (section) {
                    case '3a':
                        propertyIndex = 0;
                        break;
                    case '3b':
                        propertyIndex = isPurchase ? 1 : 0;
                        break;
                    case '3c':
                        propertyIndex = isPurchase ? 2 : 1;
                        break;
                    default:
                        // 处理 Extra cases
                        if (section.startsWith('Extra ')) {
                            const extraNum = parseInt(section.split(' ')[1]);
                            propertyIndex = isPurchase ? 
                                (2 + extraNum) : // purchase case
                                (1 + extraNum);  // non-purchase case
                        }
                }

                if (section === '3a' && !isPurchase) {
                    // Subject property case
                    const currentLoans = application.property.loans || [];
                    const newLoans = [...currentLoans, ...liabilities];
                    changeMainProperty(newLoans, "loans");
                } else {
                    // Other properties
                    const currentProperties = application[currentView].ownedproperties;
                    const currentProperty = currentProperties[propertyIndex] || {};
                    const currentLoans = currentProperty.loans || [];
                    const newLoans = [...currentLoans, ...liabilities];

                    if (currentView === "borrower") {
                        changeBorrowerOwnedProperty(newLoans, propertyIndex, "loans");
                    } else if (currentView === "coborrower") {
                        changeCoborrowerOwnedProperty(newLoans, propertyIndex, "loans");
                    }
                }
            });
        } else {
             // 遍历每个 property 的选中状态进行更新
            properties.forEach(property => {
                const selectedLoans = LiabilitiesList.filter(loan => 
                    propertyMortgages[property.section]?.includes(loan.key)
                ).map(loan => ({
                    ...loan,
                    creditloantype: "ConventionalRealEstateMortgage"
                }));

                const isPurchase = application.property.purpose === "purchase";
                if (property.section === '3a' && !isPurchase) {
                    changeMainProperty(selectedLoans, "loans");
                } else {
                    const propertyIndex = getPropertyIndex(property.section, isPurchase);
                    if (currentView === "borrower") {
                        changeBorrowerOwnedProperty(selectedLoans, propertyIndex, "loans");
                    } else if (currentView === "coborrower") {
                        changeCoborrowerOwnedProperty(selectedLoans, propertyIndex, "loans");
                    }
                }
            });
        }
    }
    const footer = [
        <Button type='link' className='link-modal-footer-back' onClick={onCancel}>Cancel</Button>,
        <Button type='primary' className='link-modal-footer-link' onClick={handleConfirm}>link to {linkType === 'property' ? 'property' : 'mortgage'}</Button>
    ]
    const getLinkIcon = (linked) => {
        return linked ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                <g clip-path="url(#clip0_1003_20881)">
                    <path d="M6.13037 8.25H12.1304V9.75H6.13037V8.25ZM15.2054 9H16.6304C16.6304 6.93 14.9504 5.25 12.8804 5.25H9.88037V6.675H12.8804C14.1629 6.675 15.2054 7.7175 15.2054 9ZM3.05537 9C3.05537 7.7175 4.09787 6.675 5.38037 6.675H8.38037V5.25H5.38037C3.31037 5.25 1.63037 6.93 1.63037 9C1.63037 11.07 3.31037 12.75 5.38037 12.75H8.38037V11.325H5.38037C4.09787 11.325 3.05537 10.2825 3.05537 9Z" fill="#325CEB"/>
                    <path d="M11.1304 12.5L12.6304 14L15.6304 11" stroke="#325CEB" stroke-width="1.5" stroke-linecap="square"/>
                </g>
                <defs>
                    <clipPath id="clip0_1003_20881">
                        <rect width="18" height="18" fill="white" transform="translate(0.130371)"/>
                    </clipPath>
                </defs>
            </svg>
        ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                <g clip-path="url(#clip0_1003_3557)">
                    <path d="M12.8805 5.25H9.88049V6.675H12.8805C14.163 6.675 15.2055 7.7175 15.2055 9C15.2055 10.0725 14.4705 10.9725 13.473 11.235L14.568 12.33C15.7905 11.7075 16.6305 10.4625 16.6305 9C16.6305 6.93 14.9505 5.25 12.8805 5.25ZM12.1305 8.25H10.488L11.988 9.75H12.1305V8.25ZM1.63049 3.2025L3.96299 5.535C3.27389 5.81538 2.68396 6.29475 2.26851 6.91191C1.85306 7.52907 1.63094 8.25603 1.63049 9C1.63049 11.07 3.31049 12.75 5.38049 12.75H8.38049V11.325H5.38049C4.09799 11.325 3.05549 10.2825 3.05549 9C3.05549 7.8075 3.96299 6.825 5.12549 6.6975L6.67799 8.25H6.13049V9.75H8.17799L9.88049 11.4525V12.75H11.178L14.1855 15.75L15.1305 14.805L2.58299 2.25L1.63049 3.2025Z" fill="#CB8600"/>
                </g>
                <defs>
                    <clipPath id="clip0_1003_3557">
                        <rect width="18" height="18" fill="white" transform="translate(0.130493)"/>
                    </clipPath>
                </defs>
            </svg>
        )
    }
    const transparentLinkIcon = (linked) => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                <g clip-path="url(#clip0_1297_25269)">
                    <path d="M6.13086 8.25H12.1309V9.75H6.13086V8.25ZM15.2059 9H16.6309C16.6309 6.93 14.9509 5.25 12.8809 5.25H9.88086V6.675H12.8809C14.1634 6.675 15.2059 7.7175 15.2059 9ZM3.05586 9C3.05586 7.7175 4.09836 6.675 5.38086 6.675H8.38086V5.25H5.38086C3.31086 5.25 1.63086 6.93 1.63086 9C1.63086 11.07 3.31086 12.75 5.38086 12.75H8.38086V11.325H5.38086C4.09836 11.325 3.05586 10.2825 3.05586 9Z" fill="white"/>
                    <path d="M11.1309 12.5L12.6309 14L15.6309 11" stroke="white" stroke-width="1.5" stroke-linecap="square"/>
                </g>
                <defs>
                    <clipPath id="clip0_1297_25269">
                        <rect width="18" height="18" fill="white" transform="translate(0.130859)"/>
                    </clipPath>
                </defs>
            </svg>
        )
    }
    const getProperties = (application, currentView) => {
        const isPurchase = application.property.purpose === "purchase"
        let properties = []
        const getSection = (index) => {
            if (index === 0) return '3a'
            if (index === 1) return '3b'
            if (index === 2) return '3c'
            return `Extra ${index - 2}`
        }
        const getSectionDescription = (index) => {
            if (index === 0) return "Section 3a. Property you own"
            if (index === 1) return "Section 3b. Additional Property"
            if (index === 2) return "Section 3c. Additional Property"
            return `Extra Property ${index - 2}`
        }
    
        if (!isPurchase) {
            properties.push({
                address: application.property.address,
                shortaddress: application.property.address.split(',')[0],
                state: application.property.state,
                county: application.property.county,
                zipcode: application.property.zipcode,
                propertyValue: application.property.appraisal,
                insurancemaintenancetaxes: application.property.insurancemaintenancetaxes,
                section: getSection(0),
                sectionDescription: getSectionDescription(0),
                status: application.property.status,
                propertytype: application.property.propertytype,
                occupancy: application.property.occupancy,
                loans: application.property.loans && application.property.loans.length > 0 
                ? application.property.loans 
                : []
            })
    
            application[currentView].ownedproperties.forEach((property, index) => {
                properties.push({
                    address: property.address,
                    shortaddress: property.address.split(',')[0],
                    state: property.state,
                    county: property.county,
                    zipcode: property.zipcode,
                    propertyValue: property.appraisal,
                    insurancemaintenancetaxes: property.insurancemaintenancetaxes,
                    section: getSection(index + 1),
                    sectionDescription: getSectionDescription(index + 1),
                    status: property.status,
                    propertytype: property.propertytype,
                    occupancy: property.occupancy,
                    loans: property.loans && property.loans.length > 0 
                    ? property.loans 
                    : []
                })
            })
        } else {
            application[currentView].ownedproperties.forEach((property, index) => {
                properties.push({
                    address: property.address,
                    shortaddress: property.address.split(',')[0],
                    state: property.state,
                    county: property.county,
                    zipcode: property.zipcode,
                    propertyValue: property.marketvalue,
                    insurancemaintenancetaxes: property.insurancemaintenancetaxes,
                    section: getSection(index),
                    sectionDescription: getSectionDescription(index),
                    status: property.status,
                    propertytype: property.propertytype,
                    occupancy: property.occupancy,
                    loans: property.loans && property.loans.length > 0 
                    ? property.loans 
                    : []
                })
            })
        }
    
        return properties.filter(property => property.address !== "")
    }
    const SingleFamilyIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
            <path d="M2.85471 7.00023H1.53847L7.46154 1.07715L13.3846 7.00023H12.0684" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.85471 7.00023V11.6071C2.85471 11.9562 2.99338 12.2909 3.24022 12.5378C3.48707 12.7846 3.82186 12.9233 4.17095 12.9233H10.7521C11.1012 12.9233 11.436 12.7846 11.6829 12.5378C11.9297 12.2909 12.0684 11.9562 12.0684 11.6071V7.00023" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.14531 7.00023H8.77778V9.6327H6.14531V7.00023Z" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )    
    const TownhouseIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M5.70367 12.3847V1.61548L12.8333 7.96656" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.1852 7.59848C12.1852 8.69535 12.1852 10.231 12.1852 11.1882C12.1852 12.1455 11.321 12.3848 10.8889 12.3848C8.51235 12.3848 3.50001 12.3848 2.46297 12.3848C1.42593 12.3848 1.16667 11.5871 1.16667 11.1882V5.20532H5.37963" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
    const MultiFamilyIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
            <path d="M10.7692 1.15381L12.3846 5.4615" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.23077 1.15381L1.61539 5.4615" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 5.46143L7 10.846" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.23077 8.15381H10.7692" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.69231 5.86182V9.89259C2.69231 10.219 2.82198 10.5321 3.05279 10.7629C3.2836 10.9937 3.59666 11.1234 3.92308 11.1234H10.0769C10.4033 11.1234 10.7164 10.9937 10.9472 10.7629C11.178 10.5321 11.3077 10.219 11.3077 9.89259V5.86182" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.61539 5.46143L12.3846 5.46142" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.23077 1.15381H10.7692" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
    const CondoIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M3.56114 7.67627H5.58037V11.0417H3.56114V7.67627Z" stroke="#586570" stroke-width="1.07692" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.15819 1.1582H10.9355" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.15819 6.09399H10.9355" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.70137 1.70142V9.85863C1.70137 10.4534 2.18353 10.9356 2.77829 10.9356H9.31541C9.91017 10.9356 10.3923 10.4534 10.3923 9.85864V1.70142" stroke="#586570" stroke-width="1.07692" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
    const getPropertyTypeTag = (propertyType) => {
        const propertyTypeOptions = {
            'singlefamily': {
                icon: <SingleFamilyIcon />,
                label: 'Single family'
            },
            'singlefamilyattached': {
                icon: <SingleFamilyIcon />,
                label: 'Single family'
            },
            'townhouse': {
                icon: <TownhouseIcon />,
                label: 'Townhouse'
            },
            'singlefamilydetached': {
                icon: <TownhouseIcon />,
                label: 'Townhouse'
            },
            'twotofour': {
                icon: <MultiFamilyIcon />,
                label: 'Multi-family'
            },
            'twotofourfamily': {
                icon: <MultiFamilyIcon />,
                label: 'Multi-family'
            },
            'condominium': {
                icon: <CondoIcon />,
                label: 'Condo'
            }
        }
    
        const option = propertyTypeOptions[propertyType]
        if (!option) return null
    
        return (
            <div className="property-type-tag">
                {option.icon}
                <span className="property-type-label">{option.label}</span>
            </div>
        )
    }
    const occupancyOptions = [
        { value: "principal", label: "Primary Residence" },
        { value: "secondhome", label: "Second Home" },
        { value: "investment", label: "Investment" },
        application.property.purpose !== "purchase" ?
            { value: "fhasecond", label: "FHA Secondary Residence" }
            : { value: "other", label: "Other" },
    ]
    const PropertyTypeOptions = [
        { value: application.property.purpose !== "purchase" ? "singlefamilyattached" : "singlefamily", label: "Single family" },
        { value: application.property.purpose !== "purchase" ? "singlefamilydetached" : "townhouse", label: "Townhouse" },
        { value: application.property.purpose !== "purchase" ? "twotofourfamily" : "twotofour", label: "Multi family" },
        { value: "condominium", label: "Condo" },
    ]
    const statusOptions = [
        { value: "sold", label: "Sold" },
        { value: "pending", label: "Pending sale" },
        { value: "retained", label: "Retained" },
    ]
    const getOccupancyLabel = (value) => {
        const option = occupancyOptions.find(opt => opt.value === value)
        return option ? option.label : value
    }
    const getPropertyTypeLabel = (value) => {
        const option = PropertyTypeOptions.find(opt => opt.value === value)
        return option ? option.label : value
    }
    const getStatusLabel = (value) => {
        const option = statusOptions.find(opt => opt.value === value)
        return option ? option.label : value
    }
    const PropertyOption = ({ data }) => {
        const isPropertyIncomplete = () => {
            const requiredFields = [
                'address',
                'insurancemaintenancetaxes',
                'status',
                'propertytype',
                'occupancy'
            ]
            
            return requiredFields.some(field => {
                const value = data[field]
                return value === '' || value === null || value === undefined
            })
        }
        return (
            <div className="property-option">
                <div className="property-top">
                    <div className="property-title">{data.address}</div>
                    <div className="property-price">${data.insurancemaintenancetaxes ? com.commaize(data.insurancemaintenancetaxes) : '-'}</div>
                </div>
                <div className="property-middle">
                    <div>{data.sectionDescription}</div>
                    {isPropertyIncomplete() && (
                        <div className="property-incomplete">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <rect width="18" height="18" rx="9" fill="#CB8600"/>
                                <rect x="8" y="4" width="2" height="7" rx="1" fill="white"/>
                                <rect x="10" y="12" width="2" height="2" rx="1" transform="rotate(90 10 12)" fill="white"/>
                            </svg>
                            <div>Incomplete</div>
                        </div>
                    )}
                </div>
                <div className="property-bottom">
                    <div className='property-tag-list'>
                        {getPropertyTypeTag(data.propertytype)}
                        <div className='property-occupancy-tag'>{getOccupancyLabel(data.occupancy)}</div>
                    </div>
                    <div className='property-status'>{getStatusLabel(data.status)}</div>
                </div>
            </div>
        )
    }
    const LiabilityOption = ({ data, isSelected, disabled }) => {
        const isLiabilityIncomplete = () => {
            // 检查所有必填字段
            const requiredFields = [
                'creditliabilityaccounttype',
                'remainingbalance',
                'monthlypayment',
                'ownership'
            ];
            
            return requiredFields.some(field => {
                const value = data[field];
                // 对于金额类型的字段特殊处理
                if (field === 'remainingbalance' || field === 'monthlypayment') {
                    return !value || value === 0 || value === '-';
                }
                // 对于其他字段
                return !value || value === '' || value === '-';
            });
        }
        
        return (
            (
                <Tooltip 
                    title={disabled ? `This mortgage is already linked to ${getSectionDescription(getLinkedPropertySection(data))}` : null}
                    placement="top"
                >
                    <div className='liability-option'>
                        <div className="liability-checkbox">
                            <Checkbox checked={disabled || isSelected} disabled={disabled} />
                        </div>
                        <div className="liability-content">
                            <div className="liability-content-top">
                                <div>
                                    <div className="liability-name">{data.name}</div>
                                    <div className="liability-account">Account number: {data.accountnumber}</div>
                                </div>
                                {isLiabilityIncomplete() && (
                                    <div className="property-incomplete">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <rect width="18" height="18" rx="9" fill="#CB8600"/>
                                        <rect x="8" y="4" width="2" height="7" rx="1" fill="white"/>
                                        <rect x="10" y="12" width="2" height="2" rx="1" transform="rotate(90 10 12)" fill="white"/>
                                    </svg>
                                        <div>Incomplete</div>
                                    </div>
                                )}
                            </div>
                            <Row className="liability-details" justify="space-between">
                                <Col md={6} span={24}>
                                    <div className="liability-detail-item"><div className="liability-detail-item-label">Account type:</div><div className="liability-detail-item-value">{ data.creditliabilityaccounttype ? data.creditliabilityaccounttype : '-'}</div></div>
                                </Col>
                                <Col md={6} span={24}>
                                    <div className="liability-detail-item"><div className="liability-detail-item-label">Unpaid balance:</div><div className="liability-detail-item-value">${data.remainingbalance ? com.commaize(data.remainingbalance) : '-'}</div></div>
                                </Col>
                                <Col md={6} span={24}>
                                    <div className="liability-detail-item"><div className="liability-detail-item-label">Mo. payment:</div><div className="liability-detail-item-value">${data.monthlypayment ? com.commaize(data.monthlypayment) : '-'}</div></div>
                                </Col>
                                <Col md={6} span={24}>
                                    <div className="liability-detail-item"><div className="liability-detail-item-label">Ownership:</div><div className="liability-detail-item-value">{data.ownership ? data.ownership : '-'}</div></div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Tooltip>
            )
        )
    }
    const properties = getProperties(application, currentView)
    const propertyOptions = properties.map(property => ({
        data: property,
        value: property.address,
        label: <PropertyOption data={property} />,
        displayLabel: property.address
    }))
    const getLiabilityOptions = (liabilities, property) => {
        return liabilities.map(liability => {
            // 检查是否在当前 property 中
            const isInCurrentProperty = property.loans?.some(loan => 
                loan.key === liability.key
            );
    
            // 检查是否链接到其他 property（除了当前 property）
            const isLinkedToOther = properties.some(otherProperty => 
                otherProperty.section !== property.section && 
                otherProperty.loans?.some(loan => loan.key === liability.key)
            );
    
            return {
                value: liability.key,
                label: <LiabilityOption 
                    data={liability} 
                    isSelected={propertyMortgages[property.section]?.includes(liability.key)}
                    disabled={isLinkedToOther}
                />,
                displayLabel: liability.name,
                disabled: isLinkedToOther,
                data: liability
            };
        });
    };
    const getSectionDescription = (section) => {
        if (section === '3a') return "property 3a";
        if (section === '3b') return "property 3b";
        if (section === '3c') return "property 3c";
        if (section.startsWith('Extra ')) {
            const extraNum = parseInt(section.split(' ')[1]);
            return `extra property ${extraNum}`;
        }
        return section;
    }
    const getLinkedPropertySection = (liability) => {
        const linkedProperty = properties.find(property => 
            property.loans?.some(loan => loan.key === liability.key)
        );
        return linkedProperty?.section || '';
    };
    const handleUnlinkConfirm = () => {
        if (unlinkType === 'property') {
            // Link to property 模式下的 unlink 操作
            const { liability, liabilityIndex } = unlinkItem;
            // 1. 清除当前 liability 的 linkedProperty
            const updatedLiability = {
                ...liability,
                linkedProperty: ''
            };
            
            // 2. 更新 LiabilitiesList
            const updatedList = LiabilitiesList.map(item => 
                item.key === liability.key ? updatedLiability : item
            );
            setLiabilitiesList(updatedList);
        
            // 清除选中值
            setSelectedValues(prev => ({
                ...prev,
                [liabilityIndex]: null
            }));

            // 从 properties 中删除的逻辑...
            const isPurchase = application.property.purpose === "purchase";
            if (!isPurchase) {
                const mainPropertyLoans = application.property.loans || [];
                const filteredMainLoans = mainPropertyLoans.filter(loan => loan.key !== liability.key);
                changeMainProperty(filteredMainLoans, "loans");
            }

            const ownedProperties = application[currentView].ownedproperties;
            ownedProperties.forEach((property, index) => {
                const currentLoans = property.loans || [];
                const filteredLoans = currentLoans.filter(loan => loan.key !== liability.key);
                if (currentView === "borrower") {
                    changeBorrowerOwnedProperty(filteredLoans, index, "loans");
                } else if (currentView === "coborrower") {
                    changeCoborrowerOwnedProperty(filteredLoans, index, "loans");
                }
            });
        } else {
            // Link to mortgage 模式下的 unlink 操作
            const { property } = unlinkItem;
            // 清除该 property 的所有选中状态
            setPropertyMortgages(prev => ({
                ...prev,
                [property.section]: []
            }));
            
            // 更新 redux 状态
            const isPurchase = application.property.purpose === "purchase";
            if (property.section === '3a' && !isPurchase) {
                changeMainProperty([], "loans");
            } else {
                const propertyIndex = getPropertyIndex(property.section, isPurchase);
                if (currentView === "borrower") {
                    changeBorrowerOwnedProperty([], propertyIndex, "loans");
                } else if (currentView === "coborrower") {
                    changeCoborrowerOwnedProperty([], propertyIndex, "loans");
                }
            }
        }
        unlinkCancel()
    }

    const isLiabilityIncomplete = (liability) => {
        // 检查所有必填字段
        const requiredFields = [
            'creditliabilityaccounttype',
            'name',
            'accountnumber',
            'remainingbalance',
            'monthlypayment',
            'ownership'
        ];
        
        return requiredFields.some(field => {
            const value = liability[field];
            return value === '' || value === null || value === undefined || value === '-';
        });
    };
    const isPropertyIncomplete = (property) => {
        // 检查所有必填字段
        const requiredFields = [
            'address',
            'state',
            'county',
            'zipcode',
            'propertyValue',
            'occupancy',
            'propertytype',
            'status',
            'insurancemaintenancetaxes'
        ];
        
        return requiredFields.some(field => {
            const value = property[field];
            // 对于数字类型的字段（propertyValue, insurancemaintenancetaxes）特殊处理
            if (field === 'propertyValue' || field === 'insurancemaintenancetaxes') {
                return !value || value === 0 || value === '-';
            }
            // 对于其他字段
            return !value || value === '' || value === '-';
        });
    };
    const handleUnlinkClick = (type, item) => {
        setUnlinkType(type)
        setUnlinkItem(item)
        setUnlinkOpen(true)
    }
    const unlinkCancel = () => {
        setUnlinkOpen(false)
        setUnlinkItem(null)
    }
    const unlinkFooter = [
        <Button type='link' className='link-modal-footer-back' onClick={unlinkCancel}>Cancel</Button>,
        <Button type='primary' className='link-modal-footer-link' onClick={handleUnlinkConfirm}>Unlink</Button>
    ]
    return (
        <>
            <Modal
                className='link-modal'
                maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
                maskClosable={false}
                width={974}
                open={open}
                centered
                destroyOnClose
                title={linkType === 'property' ? 'Link to property' : 'Link to mortgage'}
                onCancel={onCancel}
                footer={footer}
            >
                <div className='link-modal-content'>
                    <div className='link-modal-content-title'>{linkType === 'property' ? 'Link mortgage liabilities to properties listed in Section 3.' : 'Link properties to mortgage liabilities listed in Section 3.'}</div>
                    {
                        linkType === 'property' && properties.length === 0 && (
                            <div className='link-modal-warning-card'>
                                <div className='link-modal-warning-icon'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="34" viewBox="0 0 37 34" fill="none">
                                        <path d="M15.5871 4.18709C16.757 2.27339 19.5365 2.27339 20.7063 4.18709L30.9447 20.9353C32.1668 22.9343 30.7281 25.5 28.3851 25.5H7.90836C5.56537 25.5 4.1267 22.9343 5.34874 20.9353L15.5871 4.18709Z" fill="#CB8600"/>
                                        <path d="M19.9104 7L19.6104 18.1768H16.6831L16.3922 7H19.9104ZM18.1467 23C17.5952 23 17.1225 22.8351 16.7285 22.5053C16.3407 22.1755 16.1467 21.7736 16.1467 21.2995C16.1467 20.8357 16.3407 20.439 16.7285 20.1092C17.1225 19.7794 17.5952 19.6145 18.1467 19.6145C18.6861 19.6145 19.1528 19.7794 19.5467 20.1092C19.9467 20.439 20.1467 20.8357 20.1467 21.2995C20.1467 21.6138 20.0528 21.8998 19.8649 22.1575C19.6831 22.4151 19.4407 22.6213 19.1376 22.7758C18.8407 22.9253 18.5104 23 18.1467 23Z" fill="white"/>
                                    </svg>
                                </div>
                                <div className='link-modal-warning-content'>
                                    <div className='link-modal-warning-content-title'>No properties</div>
                                    <div className='link-modal-warning-content-text'>No properties are currently listed in Section 3. Please add a property before linking this liability.</div>
                                    <div className='link-modal-warning-content-button' onClick={() => {
                                        onCancel();
                                        const element = document.getElementById('3a')
                                        if (element) {
                                            element.scrollIntoView({ 
                                                behavior: 'smooth',
                                                block: 'start'
                                            })
                                        }
                                    }}>Add property in Section 3</div>
                                </div>
                            </div>
                        )
                    }
                    <div className='link-modal-list'>
                        {
                            linkType === 'property' ? (
                                LiabilitiesList.map((liability, liabilityIndex) => {
                                    const isLinked = properties.some(property => 
                                        property.loans?.some(loan => loan.key === liability.key)
                                    )
                                    return (
                                        <div className='link-modal-list-item'>
                                            <div className='link-modal-list-item-header'>
                                                <div className='link-modal-item-title'>
                                                    <div className='link-modal-item-title-text'>
                                                        <span>{liability.name}</span>
                                                        {isLiabilityIncomplete(liability) && (
                                                            <div className="property-incomplete">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                    <rect width="18" height="18" rx="9" fill="#CB8600"/>
                                                                    <rect x="8" y="4" width="2" height="7" rx="1" fill="white"/>
                                                                    <rect x="10" y="12" width="2" height="2" rx="1" transform="rotate(90 10 12)" fill="white"/>
                                                                </svg>
                                                                <div>Incomplete</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {isLinked ? (
                                                        <Tooltip 
                                                            title="Click to unlink" 
                                                            placement="top"
                                                        >
                                                            <div 
                                                                className={`link-modal-item-title-link property-link linked`}
                                                                onClick={() => {
                                                                    // 获取当前 liability 关联的 property
                                                                    const linkedProperty = properties.find(property => 
                                                                        property.loans?.some(loan => loan.key === liability.key)
                                                                    );
                                                                    
                                                                    handleUnlinkClick('property', { 
                                                                        property: linkedProperty,
                                                                        liability, 
                                                                        liabilityIndex 
                                                                    });
                                                                }}
                                                            >
                                                                <span className="default-icon">{getLinkIcon(true)}</span>
                                                                <span className="hover-icon">{transparentLinkIcon(true)}</span>
                                                                Linked
                                                            </div>
                                                        </Tooltip>
                                                    ) : (
                                                        <div className={`link-modal-item-title-link property-link unlinked`}>
                                                            <span className="default-icon">{getLinkIcon(false)}</span>
                                                            <span className="hover-icon">{transparentLinkIcon(false)}</span>
                                                            Unlinked
                                                        </div>
                                                    )}
                                                </div>
                                                <div className='link-modal-item-account-number'>Account number: {liability.accountnumber}</div>
                                            </div>
                                            <div className='link-modal-item-content'>
                                                <Row gutter={[64, 24]}>
                                                    <Col md={6} span={24}>
                                                        <div className='link-modal-item-title'>Account type</div>
                                                        <div className='link-modal-item-value'>{liability.creditliabilityaccounttype}</div>
                                                    </Col>
                                                    <Col md={6} span={24}>
                                                        <div className='link-modal-item-title'>Company name</div>
                                                        <div className='link-modal-item-value'>{liability.name}</div>
                                                    </Col>
                                                    <Col md={6} span={24}>
                                                        <div className='link-modal-item-title'>Account number</div>
                                                        <div className='link-modal-item-value'>{liability.accountnumber}</div>
                                                    </Col>
                                                    <Col md={6} span={24}>
                                                        <div className='link-modal-item-title'>Unpaid balance</div>
                                                        <div className='link-modal-item-value'>${liability.remainingbalance ? com.commaize(liability.remainingbalance) : '-'}</div>
                                                    </Col>
                                                    <Col md={6} span={24}>
                                                        <div className='link-modal-item-title'>Mo. payment</div>
                                                        <div className='link-modal-item-value'>${liability.monthlypayment ? com.commaize(liability.monthlypayment) : '-'}</div>
                                                    </Col>
                                                    <Col md={6} span={24}>
                                                        <div className='link-modal-item-title'>Ownership</div>
                                                        <div className='link-modal-item-value'>{liability.ownership}</div>
                                                    </Col>
                                                </Row>
                                                <Row style={{ marginTop: 32 }}>
                                                    <Col md={24} span={24}>
                                                        <div className='link-modal-item-title'>Select a property</div>
                                                        <Select 
                                                            className='link-modal-item-select'
                                                            style={{ width: '100%' }}
                                                            listHeight={272}
                                                            getPopupContainer={triggerNode => triggerNode.parentElement}
                                                            placeholder={properties.length === 0 ? 'No properties are currently listed' : 'Select a property from section3'}
                                                            options={propertyOptions}
                                                            value={(selectedValues[liabilityIndex] || getSelectedProperty(liability, properties))?.value}
                                                            labelInValue
                                                            onChange={(_, option) => handleLinkChange(liabilityIndex, option)}
                                                            optionLabelProp="displayLabel"
                                                            suffixIcon={
                                                                <div style={{ display: 'flex', justifyContent: 'center', width: 32, height: 32, paddingTop: 5 }}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                                                                        <rect width="1.98616" height="11.917" rx="0.99308" transform="matrix(0.712034 -0.702145 0.712034 0.702145 0.630554 8.52026)" fill="#222222"/>
                                                                        <rect width="1.98616" height="11.917" rx="0.99308" transform="matrix(0.712034 0.702145 -0.712034 0.702145 16.1869 7.12573)" fill="#222222"/>
                                                                    </svg>
                                                                </div>
                                                            }
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    )
                                })
                            ) : (
                                properties.map((property, propertyIndex) => (
                                    <div className='link-modal-list-item'>
                                        <div className='link-modal-list-item-header'>
                                            <div className='link-modal-item-title'>
                                                <div className='link-modal-item-title-text'>
                                                    <span>{property.address}</span>
                                                    {isPropertyIncomplete(property) && (
                                                        <div className="property-incomplete">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                <rect width="18" height="18" rx="9" fill="#CB8600"/>
                                                                <rect x="8" y="4" width="2" height="7" rx="1" fill="white"/>
                                                                <rect x="10" y="12" width="2" height="2" rx="1" transform="rotate(90 10 12)" fill="white"/>
                                                            </svg>
                                                            <div>Incomplete</div>
                                                        </div>
                                                    )}
                                                </div>
                                                {propertyMortgages[property.section]?.length > 0 ? (
                                                    <Tooltip 
                                                        title="Click to unlink" 
                                                        placement="top"
                                                    >
                                                        <div 
                                                            className={`link-modal-item-title-link property-link linked`}
                                                            onClick={() => {
                                                                // 获取当前 property section 下选中的所有 mortgages
                                                                const selectedMortgages = LiabilitiesList.filter(liability => 
                                                                    propertyMortgages[property.section]?.includes(liability.key)
                                                                );
                                                                
                                                                handleUnlinkClick('mortgage', { 
                                                                    property,
                                                                    liabilities: selectedMortgages
                                                                });
                                                            }}
                                                        >
                                                            <span className="default-icon">{getLinkIcon(true)}</span>
                                                            <span className="hover-icon">{transparentLinkIcon(true)}</span>
                                                            Linked
                                                        </div>
                                                    </Tooltip>
                                                ) : (
                                                    <div className={`link-modal-item-title-link property-link unlinked`}>
                                                        <span className="default-icon">{getLinkIcon(false)}</span>
                                                        <span className="hover-icon">{transparentLinkIcon(false)}</span>
                                                        Unlinked
                                                    </div>
                                                )}
                                            </div>
                                            <div className='link-modal-item-account-number'>{property.sectionDescription}</div>
                                        </div>
                                        <div className='link-modal-item-content'>
                                            <Row gutter={[0, 24]}>
                                                <Col md={6} span={24}>
                                                    <div className='link-modal-item-title'>Address</div>
                                                    <div className='link-modal-item-value'>{property.shortaddress}</div>
                                                </Col>
                                                <Col md={6} span={24}>
                                                    <div className='link-modal-item-title'>State</div>
                                                    <div className='link-modal-item-value'>{property.state ? property.state : '-'}</div>
                                                </Col>
                                                <Col md={6} span={24}>
                                                    <div className='link-modal-item-title'>County</div>
                                                    <div className='link-modal-item-value'>{property.county ? property.county : '-'}</div>
                                                </Col>
                                                <Col md={6} span={24}>
                                                    <div className='link-modal-item-title'>Zip</div>
                                                    <div className='link-modal-item-value'>{property.zipcode}</div>
                                                </Col>
                                                <Col md={6} span={24}>
                                                    <div className='link-modal-item-title'>Property Value</div>
                                                    <div className='link-modal-item-value'>${property.propertyValue ? com.commaize(property.propertyValue) : '-'}</div>
                                                </Col>
                                                <Col md={6} span={24}>
                                                    <div className='link-modal-item-title'>Intended occupancy</div>
                                                    <div className='link-modal-item-value'>{property.occupancy ? getOccupancyLabel(property.occupancy) : '-'}</div>
                                                </Col>
                                                <Col md={6} span={24}>
                                                    <div className='link-modal-item-title'>Property type</div>
                                                    <div className='link-modal-item-value'>{property.propertytype ? getPropertyTypeLabel(property.propertytype) : '-'}</div>
                                                </Col>
                                                <Col md={6} span={24}>
                                                    <div className='link-modal-item-title'>Status</div>
                                                    <div className='link-modal-item-value'>{property.status ? getStatusLabel(property.status) : '-'}</div>
                                                </Col>
                                                <Col span={24}>
                                                    <div className='link-modal-item-title'>Monthly insurance, taxes, association dues</div>
                                                    <div className='link-modal-item-value'>${property.insurancemaintenancetaxes ? com.commaize(property.insurancemaintenancetaxes) : '-'}</div>
                                                </Col>
                                            </Row>
                                            <Row style={{ marginTop: 32 }}>
                                                <Col md={24} span={24}>
                                                    <div className='link-modal-item-title'>Select a mortgage</div>
                                                    <Select 
                                                        className='link-modal-item-select'
                                                        style={{ width: '100%' }}
                                                        listHeight={332}
                                                        getPopupContainer={triggerNode => triggerNode.parentElement}
                                                        placeholder='Select a mortgage from section2c'
                                                        options={getLiabilityOptions(LiabilitiesList, property)}
                                                        mode="multiple"
                                                        showSearch={false}
                                                        maxTagCount={0}
                                                        maxTagPlaceholder={(selectedOptions) => {
                                                            const count = selectedOptions.filter(option => 
                                                                LiabilitiesList.some(liability => liability.key === option.value)
                                                            ).length;
                                                            return `${count} mortgage${count !== 1 ? 's' : ''} selected`;
                                                        }}   
                                                        value={propertyMortgages[property.section] || []}
                                                        labelInValue
                                                        onChange={(values) => {
                                                            setPropertyMortgages(prev => ({
                                                                ...prev,
                                                                [property.section]: values.map(v => v.value)
                                                            }));
                                                        }}
                                                        optionLabelProp="displayLabel"
                                                        suffixIcon={
                                                            <div style={{ display: 'flex', justifyContent: 'center', width: 32, height: 32, paddingTop: 5 }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                                                                    <rect width="1.98616" height="11.917" rx="0.99308" transform="matrix(0.712034 -0.702145 0.712034 0.702145 0.630554 8.52026)" fill="#222222"/>
                                                                    <rect width="1.98616" height="11.917" rx="0.99308" transform="matrix(0.712034 0.702145 -0.712034 0.702145 16.1869 7.12573)" fill="#222222"/>
                                                                </svg>
                                                            </div>
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                ))
                            )
                        }
                    </div>
                </div>
            </Modal>
            <Modal
                className='unlink-modal'
                mask={false}
                width={410}
                open={unlinkOpen}
                centered
                destroyOnClose
                title={`Unlink ${unlinkType === 'property' ? 'mortgage' : 'property'} from ${unlinkType}`}
                onCancel={unlinkCancel}
                footer={unlinkFooter}
            >
                <div>
                    {unlinkType === 'property' ? (
                        <div className='unlink-modal-content'>Are you sure you want to unlink this mortgage from the property: {unlinkItem?.property?.address}?</div>
                    ) : (
                        <div className='unlink-modal-content'>
                            Are you sure you want to unlink this property from the mortgage: {
                                unlinkItem?.liabilities?.map(liability => 
                                    `${liability.name} (${liability.accountnumber})`
                                ).join(', ')
                            }?
                        </div>
                    )}
                </div>
            </Modal>
        </>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkModal)